import React from 'react';
import { Form } from 'react-bootstrap';

const InputForm = ({...props}) => {
    return (
        <Form.Control {...props} />
    );
};

export default InputForm;